import React from 'react';
import { BookOpenIcon, EyeIcon, ShieldIcon, SunIcon } from 'lucide-react';
export function ContentSection() {
  const tomos = [{
    num: 1,
    title: 'Entiende tu mente',
    desc: 'Descubre por qué la mente genera sobrepensamiento y cómo empezar a reducirlo.',
    icon: BookOpenIcon
  }, {
    num: 2,
    title: 'Observa tus pensamientos',
    desc: 'Aprende a observar los pensamientos sin reaccionar automáticamente.',
    icon: EyeIcon
  }, {
    num: 3,
    title: 'Domina tu mundo interior',
    desc: 'Desarrolla estabilidad mental y control emocional.',
    icon: ShieldIcon
  }, {
    num: 4,
    title: 'El camino hacia la verdadera paz mental',
    desc: 'La enseñanza final para vivir con una mente más tranquila y clara.',
    icon: SunIcon
  }];
  return <section className="bg-[#2a1f14] text-white py-20 px-4" data-id="element-61">
      <div className="max-w-5xl mx-auto" data-id="element-62">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-center mb-16 uppercase tracking-tight" data-id="element-63">
          Dentro del Mega Pack Claridad Mental encontrarás
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-64">
          {tomos.map(tomo => <div key={tomo.num} className="bg-[#3d2e20] border border-[#5a4535] rounded-xl p-8 relative overflow-hidden group hover:border-[#c9a96e] transition-colors duration-300" data-id="element-65">
              <div className="absolute top-0 right-0 bg-[#b5634b] text-white font-oswald font-bold px-4 py-1 rounded-bl-lg text-lg" data-id="element-66">
                TOMO {tomo.num}
              </div>

              <tomo.icon className="w-12 h-12 text-[#c9a96e] mb-6 opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-67" />

              <h3 className="font-oswald text-2xl md:text-3xl font-bold mb-4 text-white uppercase" data-id="element-68">
                {tomo.title}
              </h3>

              <p className="font-opensans text-lg text-gray-300 leading-relaxed" data-id="element-69">
                {tomo.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}